/**
 * `/item/*` routes v2 calls (API_ACCESS.md §3.1), held to the snapshot by `api/routes.test.ts`.
 */
import { gated } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

/** an item's stock at a branch; the customiser reads `itemQty` and `measuringUnit` */
export interface ItemStock {
  itemId?: string;
  itemQty?: number;
  measuringUnit?: string;
}

export const ITEM = defineRoutes("item", {
  branchFetchAll: route<undefined, unknown>("GET", "/item/branch/fetchAll", gated({ modules: ["Sale", "Order", "Kiosk"] }), {
    notes:
      "the branch's catalogue items; `catalog/fetch` (P1 slice 4). v1's session bootstrap sends it too until New Order's cutover",
  }),
  inventoryFetch: route<undefined, ItemStock>("GET", "/item/inventory/fetch", gated({ modules: ["Sale", "Order", "Kiosk"] }), {
    notes:
      "one item's stock at a branch (query `itemId`, `branchId`): the customiser's More details (P1 slice 5, both apps). v1 web's popup fetches it through `saga/inventory`; mobile v1's dispatch has no watcher",
  }),
});
